export default "__VITE_ASSET__DmCqojRt__"